<template>
  <div v-if="renderReady && !model.$disabled">
    <label v-if="getTitle" class="label">
      <w-next-number v-bind="nextNumber" v-if="nextNumber" />

      <template>{{ getTitle }}</template>
      &nbsp;
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{ tooltipContent }}</w-tooltip>
    </label>

    <w-description :model="model" v-bind="description">
      <slot name="description" />
    </w-description>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-label',
  components: {WTooltip},
  props: {
    description: {
      type: Object,
      default: () => ({
        value: '',
        tooltip: false,
        htmlContent: false
      }),
      required: false
    },
    nextNumber: {
      type: Object,
      default: null,
      required: false
    },
    css: [Object, String, Array]
  },
  mixins: [modelMixin]
};
</script>
